var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3136 11.6683C17.4426 11.0999 17.505 10.5185 17.4997 9.93564C17.4651 5.80835 14.0501 2.45881 9.9229 2.50038C8.16012 2.51881 6.46014 3.15749 5.12131 4.30433C3.78248 5.45118 2.89033 7.03291 2.60143 8.77196C2.31253 10.511 2.64534 12.2962 3.54146 13.8144C4.43758 15.3325 5.83974 16.4865 7.50188 17.0739C7.78468 17.1735 8.08725 17.2038 8.3842 17.1624C8.68116 17.1209 8.96384 17.0088 9.20853 16.8356C9.45322 16.6623 9.6528 16.4329 9.79052 16.1665C9.92823 15.9002 10.0001 15.6047 10 15.3049V15C10 14.5027 10.1976 14.0258 10.5492 13.6742C10.9008 13.3225 11.3777 13.125 11.875 13.125H15.4851C15.9098 13.1253 16.3221 12.9813 16.6543 12.7167C16.9865 12.452 17.2189 12.0824 17.3136 11.6683V11.6683Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.875C10.5178 6.875 10.9375 6.45527 10.9375 5.9375C10.9375 5.41973 10.5178 5 10 5C9.48223 5 9.0625 5.41973 9.0625 5.9375C9.0625 6.45527 9.48223 6.875 10 6.875Z",
    fill: "#8B8B8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48242 8.90625C7.00019 8.90625 7.41992 8.48652 7.41992 7.96875C7.41992 7.45098 7.00019 7.03125 6.48242 7.03125C5.96465 7.03125 5.54492 7.45098 5.54492 7.96875C5.54492 8.48652 5.96465 8.90625 6.48242 8.90625Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48242 12.9688C7.00019 12.9688 7.41992 12.549 7.41992 12.0312C7.41992 11.5135 7.00019 11.0938 6.48242 11.0938C5.96465 11.0938 5.54492 11.5135 5.54492 12.0312C5.54492 12.549 5.96465 12.9688 6.48242 12.9688Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5176 8.90625C14.0353 8.90625 14.4551 8.48652 14.4551 7.96875C14.4551 7.45098 14.0353 7.03125 13.5176 7.03125C12.9998 7.03125 12.5801 7.45098 12.5801 7.96875C12.5801 8.48652 12.9998 8.90625 13.5176 8.90625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/Palette.c1886c4dedc3691eec3376bfac057f39.svg";
export { ForwardRef as ReactComponent };